import idLocale from 'element-ui/lib/locale/lang/id' //引入element语言包 印尼语
const id = {
  Login: {
    ToLogin: 'log on',
    PhoneLogin: 'Login dengan nomor telepon',
    EmailLogin: 'Login Email',
    PhonePlaceholder: 'Silakan masukkan nomor telepon Anda',
    EmailPlaceholder: 'Enter email',
    Code: 'Kode verifikasi',
    and: 'dan',
    BeforeText: 'Membuat akun mewakili kesepakatan dan persetujuan Anda',
    UserAgreement: 'Perjanjian Pengguna',
    privacy: 'Polisi Privasi',
    errorMessage: 'Galat kode verifikasi',
    readTitle: 'Baca dan setuju dengan kesepakatan berikutnya',
    readBefore: 'Untuk memastikan keamanan informasi pribadi Anda, silakan baca dan setuju pertama',
    cancel: 'batalkan',
    agree: 'Setuju dan lanjutkan',
    error1:'Silakan masukkan alamat email yang sah',
    error2:'Masukkan nomor ponsel yang benar',
    error3:'Silakan masukkan kode verifikasi',
    success:'Login berhasil'
  },
  ...idLocale //这里引入element语言包目的是在切换语言的时候，element的组件里面的文字能跟随切换
}
// 导出
export default id;
